/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Login_Disable_Login_ScreenInputs */

const en_forms_teams_settings_login_disable_login_screen = /** @type {(inputs: Forms_Teams_Settings_Login_Disable_Login_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login Screen`)
};

const de_forms_teams_settings_login_disable_login_screen = /** @type {(inputs: Forms_Teams_Settings_Login_Disable_Login_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldemaske nicht anzeigen`)
};

/**
* | output |
* | --- |
* | "Login Screen" |
*
* @param {Forms_Teams_Settings_Login_Disable_Login_ScreenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_login_disable_login_screen = /** @type {((inputs?: Forms_Teams_Settings_Login_Disable_Login_ScreenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Login_Disable_Login_ScreenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_login_disable_login_screen(inputs)
	return de_forms_teams_settings_login_disable_login_screen(inputs)
});